export default {"src":"/_next/static/media/crown.47be5200.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};